import 'slick-carousel';
$('.top-tiktok-slides').slick({
  arrows: false,
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 4000,
  speed: 500,
  easing: 'swing',
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [{

    breakpoint: 768,
    settings: {
      centerMode: true,
      slidesToShow: 1,
      slidesToShow: 1,
    }

  }]
});
$('.environment-career-step-slides').slick({
  arrows: false,
  dots: true,
  infinite: true,
  fade: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 4000,
  speed: 500,
  easing: 'swing',
  pauseOnHover: false,
  pauseOnFocus: false
});


$('.important-comitmment-slides').slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  centerMode: true
});

